module.exports = __webpack_public_path__ + "img/magnum-club.f4076f71.svg";